var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", { class: _vm.rootClasses }, [
    _c(
      "svg",
      {
        staticStyle: { display: "block", width: "100%", height: "100%" },
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "100%",
          height: "100%",
          preserveAspectRatio: _vm.aspectRatio,
          viewBox: _vm.viewbox
        }
      },
      [
        _c("g", { attrs: { filter: _vm.filter } }, [
          _vm.isVisible
            ? _c("image", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  width: "100%",
                  height: "100%",
                  x: "0",
                  y: "0",
                  filter: "url(#svg_black_and_white)",
                  "xlink:href": _vm.imageUrl
                }
              })
            : _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#000" }
              })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca620f64", { render: render, staticRenderFns: staticRenderFns })
  }
}